import { Helmet } from 'react-helmet-async';

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
// @mui
import { Paper, Container, Typography, Grid, CircularProgress, Tabs, Tab, Box } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';

import EditClient from 'src/components/Clients/EditClient';
import ComingToCanada from 'src/components/Clients/ComingToCanada';
import DetailsOfWorkInCanada from 'src/components/Clients/DetailsOfWorkInCanada';
import EducationInfo from 'src/components/Clients/EducationInfo';
import BackgroundInfo from 'src/components/Clients/BackgroundInfo';
import PaymentInfo from 'src/components/Clients/PaymentInfo';
import ClientDependents from 'src/components/Clients/Dependents';
import { tabsClasses } from '@mui/material/Tabs';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function ClientEditPage(props) {
  let { id } = useParams();

  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('sdsdsdsds');

  useEffect(() => {}, []);

  const handleClose = () => {
    setOpen(false);
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <>
      <Helmet>
        <title> Client | Immigration System </title>
      </Helmet>
      <Container>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Box
            p={4}
            component={Paper}
            boxShadow={3}
            sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
              aria-label="primary tabs example"
              variant="scrollable"
              scrollButtons
              sx={{
                [`& .${tabsClasses.scrollButtons}`]: {
                  '&.Mui-disabled': { opacity: 0.3 },
                },
              }}
            >
              <Tab label="Edit Client" {...a11yProps(0)} />
              <Tab label="Coming To Canada" {...a11yProps(1)} />

              <Tab label="Details of Intended Work in Canada" {...a11yProps(2)} />
              <Tab label="Education" {...a11yProps(3)} />
              <Tab label="Dependents" {...a11yProps(4)} />
              <Tab label="Background Information" {...a11yProps(5)} />
              <Tab label="Payment Information" {...a11yProps(6)} />
            </Tabs>

            <SwipeableViews axis="x-reverse" index={value} onChangeIndex={handleChangeIndex}>
              <TabPanel value={value} index={0}>
                <EditClient
                  id={id}
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <ComingToCanada
                  id={id}
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <DetailsOfWorkInCanada
                  id={id}
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <EducationInfo
                  id={id}
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
              <TabPanel value={value} index={4}>
                <ClientDependents
                  id={id}
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
              <TabPanel value={value} index={5}>
                <BackgroundInfo
                  id={id}
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
              <TabPanel value={value} index={6}>
                <PaymentInfo
                  id={id}
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
            </SwipeableViews>
          </Box>
        )}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
